import { useEffect, useRef, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from './MultiSelect.module.css';

const MultiSelect = ({ value = [], onChange, options, placeholder = 'Выберите...', getKey = (opt) => opt.id, getLabel = (opt) => opt.name }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isSelected = (opt) => value.some((v) => getKey(v) === getKey(opt));

  const toggleOption = (opt) => {
    onChange(
      isSelected(opt)
        ? value.filter((v) => getKey(v) !== getKey(opt))
        : [...value, opt]
    );
  };

  const removeOption = (opt) => {
    onChange(value.filter((v) => getKey(v) !== getKey(opt)));
  };

  const filteredOptions = options.filter((opt) =>
    getLabel(opt).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={styles.multiSelect} ref={ref}>
      <button
        type="button"
        className={`${styles.trigger} ${open ? styles.triggerOpen : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        {value.length > 0 ? (
          <div className={styles.tags}>
            {value.map((opt) => (
              <span key={getKey(opt)} className={styles.tag}>
                {getLabel(opt)}
                <span
                  className={styles.tagRemove}
                  role="button"
                  tabIndex={-1}
                  onClick={(e) => {
                    e.stopPropagation();
                    removeOption(opt);
                  }}
                >
                  <FaTimes />
                </span>
              </span>
            ))}
          </div>
        ) : (
          <span className={styles.triggerPlaceholder}>{placeholder}</span>
        )}
        <svg className={`${styles.arrow} ${open ? styles.arrowOpen : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>

      {open && (
        <div className={styles.dropdown}>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Поиск..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          <div className={styles.options}>
            {filteredOptions.length === 0 ? (
              <div className={styles.empty}>Ничего не найдено</div>
            ) : filteredOptions.map((opt) => (
              <div
                key={getKey(opt)}
                className={`${styles.option} ${isSelected(opt) ? styles.optionSelected : ''}`}
                onClick={() => toggleOption(opt)}
              >
                <span className={styles.checkbox}>
                  {isSelected(opt) && (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </span>
                {getLabel(opt)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
